import { css } from 'linaria';
import { ButtonProps } from './button';
import { Variables } from '../index';
import { COLOR_LTSFC_ALERT_RED } from '@catapultsports/referee-design-tokens';

export const theme = css`
    :global() {
        [data-theme='light'] {
            --button-outline-color: ${Variables.css.catapultBlack};
            --button-color: ${Variables.css.catapultBlack};
        }

        [data-theme='dark'] {
            --button-outline-color: ${Variables.css.catapultWhite};
            --button-color: ${Variables.css.catapultWhite};
        }
    }
`;

export const root = css`
    position: relative;
    appearance: none;
    border-radius: 4px;
    border: 0;
    display: inline-grid;
    grid-auto-flow: column;
    align-items: center;
    overflow: hidden;
    gap: ${Variables.css.spacing8};
    justify-content: center;
    transition: all 0.2s ease-in-out;
    color: var(--button-color);
    padding: 0 ${Variables.css.spacing16};

    &:not([disabled]) {
        cursor: pointer;
    }

    &[href] {
        text-decoration: none;
    }
`;

export const fullWidth = css`
    width: 100%;
`;

export const iconOnly = css`
    padding: 0;
`;

export const sizes: Record<ButtonProps['size'], string> = {
    medium: css`
        min-height: 44px;
        min-width: 44px;
    `,
    small: css`
        min-height: 28px;
        min-width: 28px;
    `,
};

export const variants: Record<ButtonProps['variant'], string> = {
    primary: css`
        background: ${Variables.css.catapultOrange};
        --button-color: ${Variables.css.catapultBlack};

        &:focus-visible {
            box-shadow: 0 0 0 4px ${Variables.css.focusRing};
            outline: none;
        }
    `,
    outline: css`
        background: transparent;
        box-shadow: 0 0 0 2px var(--button-outline-color) inset;
    `,
    destruct: css`
        background: ${COLOR_LTSFC_ALERT_RED}; // always uses ltsfc alert red, does not change with theme
        --button-color: ${Variables.css.catapultWhite};

        &:focus-visible {
            box-shadow: 0 0 0 4px ${Variables.css.focusRing};
            outline: none;
        }
    `,
    text: css`
        background: transparent;

        &:focus-visible {
            box-shadow: 0 0 0 4px ${Variables.css.focusRing};
            outline: none;
        }
    `,
};

export const spinnerWrapper = css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${Variables.css.spacing8};

    &:before {
        content: '';
        height: 1.25em;
        width: 1.25em;
        border: 3px solid var(--button-color);
        border-right-color: transparent;
        border-radius: 50%;
        border-right-color: transparent;
        animation: rotate 0.75s linear infinite;
    }

    @keyframes rotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`;

export const textPosition = css`
    grid-area: 1/1/1/1;
`;

export const hide = css`
    visibility: hidden;
`;

export const unstyled = css`
    appearance: none;
    padding: 0;
    margin: 0;
    background: none;
    color: inherit;
    border: none;
    font: inherit;
    outline: inherit;
`;

export const text = css`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
